<template>
  <div class="vg-content">
    <div class="header">
      <van-image width="40" height="40" :src="srcPayOK"/>
      <div class="text">支付成功</div>
    </div>
    <van-button class="button" style="margin-top: 90px;" @click="invoice">申请开票</van-button>
    <van-button class="button" :class="{disabled: isSend}" style="margin-top: 40px;" @click="sendSms">{{ smsStr }}
    </van-button>
  </div>

</template>

<script>
import {Button, Image as VanImage, Toast} from "vant";
import srcPayOk from "@/assets/scanverify/pay-success.svg";
import {client} from "@/libraries/http";

export default {
  name: "ChargeResult",
  components: {
    VanImage, "van-button": Button,
  },
  data() {
    return {
      srcPayOK: srcPayOk,
      phoneNum: "",
      isSend: false,
      smsStr: "发送开票短信链接",
    }
  },
  created() {
    console.log(this.$route);
    this.phoneNum = this.$route.query.phoneNum;
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    invoice() {
      // this.$toast("该功能尚未开放，敬请期待。")
      this.$router.push({path: '/scanVerify/chargeInvoice', query: {phoneNum: this.phoneNum}});
    },
    sendSms() {
      if (this.isSend) {
        return;
      }
      let url = this.getInvoiceUrl();
      console.log(url);
      let params = {
        phoneNumber: this.phoneNum,
        url: url,
      };
      client.post("/api/h5/invoice/sendsms", params).then(() => {
        Toast.success('发送成功');
        this.isSend = true;
        this.smsStr = "发送开票短信链接(60秒)";
        this.count = 60;
        this.timer = setInterval(() => this.countDown(), 1000);
      })
    },
    countDown() {
      this.count--;
      if (this.count > 0) {
        this.smsStr = "发送开票短信链接(" + this.count + "秒)";
      } else {
        clearInterval(this.timer);
        this.isSend = false;
        this.smsStr = "发送开票短信链接";
      }
    },
    getInvoiceUrl() {
      let path = process.env.VUE_APP_ROUTER_BASE_URL;
      return window.location.protocol + "//" + window.location.host + (path ? path : "/") + "scanVerify/chargePhone?isInvoice=true";
    },
  },
}
</script>

<style scoped>
.vg-content {
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  align-items: center;
}

.header {
  margin-top: 45px;
  display: flex;
  align-items: center;
}

.text {
  margin-left: 15px;
  color: #4BA9F6;
  font-size: 26px;
}

.button {
  width: 225px;
  height: 44px;
  background-color: #4BA9F6;
  color: white;
  border-radius: 8px;
  font-size: 16px;
}

.disabled {
  background-color: #888888;
}

</style>
